<template>
    <v-row>
        <v-dialog v-model="showDialog" persistent max-width="350px">
            <v-form ref="form">
                <v-card>
                    <v-card-text style="padding: 20px;">
                        <v-container>
                            <v-row cols="12" justify="center">
                                <v-icon style="font-size: 50px;">mdi-email-off</v-icon>
                            </v-row>
                            <v-row cols="12" justify="center" style="margin-top: 15px;">
                                <span style="font-size: 12px; text-align: center;">{{ text }}</span>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#c01033" text class="btn-link" style="width: 100px;" @click="showDialog=false">
													{{ $t('app.buttons.close') }}
												</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-row>
</template>

<script>

export default {
    name: 'SendEmailErrorDialog',
    data() {
        return {
						text: null,
            showDialog: false,
        }
    },
    methods: {
        isVisible: function() {
            return this.showDialog;
        },
        open: function(text) {
						this.text = text;
            this.showDialog = true;
        },
        close: function() {
            this.showDialog = false;
        }
    },
  }
</script>